var _g, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#23BD86"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#23BD86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8633 32.9999C24.5873 32.9999 24.3233 32.8859 24.1343 32.6849L19.2713 27.5059C18.8923 27.1039 18.9133 26.4709 19.3153 26.0929C19.7183 25.7149 20.3513 25.7349 20.7283 26.1369L24.8533 30.5279L33.2613 21.3259C33.6353 20.9169 34.2673 20.8899 34.6753 21.2619C35.0823 21.6339 35.1103 22.2669 34.7383 22.6739L25.6013 32.6739C25.4143 32.8799 25.1483 32.9979 24.8703 32.9999H24.8633Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGreenCheck);
export default __webpack_public_path__ + "static/media/IconGreenCheck.762601b8.svg";
export { ForwardRef as ReactComponent };